// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"8eb18f4f","99":"d9e72c49"}[chunkId] + ".js";
};